export class BreadcrumbItem {
	label?: string;
	labelKey?: string;
	listItemClass?: string;
	route?: unknown[];
}
